import script from "./IconPosteTvx.vue?vue&type=script&setup=true&lang=js"
export * from "./IconPosteTvx.vue?vue&type=script&setup=true&lang=js"

import "./IconPosteTvx.vue?vue&type=style&index=0&id=1a20ba9b&scoped=true&lang=css"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a20ba9b"]])

export default __exports__